//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../no/SelectNXObjectList.js";
import "../no/SelectBody.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
let d=[[[0,"BasePlane",1,"Plane",0],[1,"BinderProfiles",0,"SelectNXObjectList",0],[0,"BinderRelief",1,0],[1,"BlankProfile",0,"SelectNXObjectList",0],[0,"BlankProfileOffset",1,0],[0,"CoreDirection",1,0],[1,"DeckProfile",0,"SelectNXObjectList",0],[0,"IsApproxSheetBody",1,0],[0,"IsExactBinderProfiles",1,0],[0,"LowerDeckThickness",1,0],[0,"MachineAllowance",1,0],[0,"OffsetValue",1,0],[0,"OutWallThickness",1,0],[1,"OutterWallProfile",0,"SelectNXObjectList",0],[1,"SheetBody",0,"SelectBody",0],[1,"UpperDeckOffsetSheet",0,"SelectBody",0],[0,"UpperDeckRelief",1,0],[1,"UpperDeckReliefSheet",0,"SelectBody",0],[0,"UpperDeckThickness",1,0],[0,"WallThickness",1,0]],[],[]];
SPLM.Tooling.DieDesignLowerBinderBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.DieDesignLowerBinderBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;